import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    CashFlowCategory,
    CashFlowClassification,
    CashFlowClassificationUpdateResult,
    CashFlowStatement,
    DayBook,
    DayBookFilters,
} from '../interfaces/accounting.interface';

const dayBookParams = (f: DayBookFilters) => ({
    from: f.from,
    to: f.to,
    ...(f.referenceType ? { referenceType: f.referenceType } : {}),
    ...(f.accountId ? { accountId: f.accountId } : {}),
    ...(f.search ? { search: f.search } : {}),
});

export const CashFlowService = {
    getStatement: async (from: string, to: string, segmentId?: string): Promise<CashFlowStatement> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.ACCOUNT.CASH_FLOW(institutionId!), {
            params: { from, to, ...(segmentId ? { segmentId } : {}) },
        });
        return response.data;
    },
    getClassifications: async (): Promise<CashFlowClassification[]> => {
        const institutionId = AuthService.getSelectedInstitution();
        return (await axios.get(ENDPOINTS.ACCOUNT.CASH_FLOW_CLASSIFICATION(institutionId!))).data;
    },
    updateClassifications: async (items: { accountId: string; category: CashFlowCategory | null }[]): Promise<CashFlowClassificationUpdateResult> => {
        const institutionId = AuthService.getSelectedInstitution();
        return (await axios.put(ENDPOINTS.ACCOUNT.CASH_FLOW_CLASSIFICATION(institutionId!), { items })).data;
    },
    getDayBook: async (filters: DayBookFilters): Promise<DayBook> => {
        const institutionId = AuthService.getSelectedInstitution();
        return (await axios.get(ENDPOINTS.ACCOUNT.DAY_BOOK(institutionId!), { params: dayBookParams(filters) })).data;
    },
    getDayBookReferenceTypes: async (): Promise<string[]> => {
        const institutionId = AuthService.getSelectedInstitution();
        return (await axios.get(ENDPOINTS.ACCOUNT.DAY_BOOK_REFERENCE_TYPES(institutionId!))).data;
    },
    downloadDayBookXlsx: async (filters: DayBookFilters): Promise<Blob> => {
        const institutionId = AuthService.getSelectedInstitution();
        return (await axios.get(ENDPOINTS.ACCOUNT.DAY_BOOK_XLSX(institutionId!), {
            params: dayBookParams(filters),
            responseType: 'blob',
        })).data;
    },
};
